import Axios from 'axios';
import { apiUrl } from './Constants';

const axiosNoToken = Axios.create({
  baseURL: apiUrl,
});

export default axiosNoToken;
